import { render, staticRenderFns } from "./BookCategory.vue?vue&type=template&id=525ad65c&"
import script from "./BookCategory.vue?vue&type=script&lang=js&"
export * from "./BookCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports